/**
 * Angular imports.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

/**
 * Module imports.
 */
import { ModalModule } from 'ngx-bootstrap/modal';
import { PipesModule } from './../../pipes/pipes.module';
import { ShakaPlayerModule } from '../../shaka-player/shaka-player.module';
import { PdfViewModule } from '../pdf-view/pdf-view.module';
import { CarouselModule } from 'angular-bootstrap-md';

/**
 * Component imports.
 */
import { MediaModalComponent } from './media-modal.component';



@NgModule({
  declarations: [
    MediaModalComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    PdfViewModule,
    CarouselModule,
    ShakaPlayerModule,
    PipesModule,
    ModalModule
  ],
  exports: [
    MediaModalComponent
  ]
})
export class MediaModalModule { }
